export enum XAxisReportPanelGroups {
  FILTERS = 'filters',
  LEGEND = 'legend',
  X_AXIS = 'xaxis',
  FUNCTIONS = 'yaxis',
}

export enum XAxisSeriesType {
  LINE = 'line',
  BAR = 'bar',
}

export enum BackendXAxisSeriesResponseType {
  LINE = 'LINE',
  BAR = 'BAR',
  COLUMN = 'COLUMN'
}
